import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Button } from 'shared/ui'
import { LINK_SURVEYS_GUIDE } from 'shared/constants/links'
import { useSurveysContext } from 'pages/surveys/context/surveysContext'
import styles from './styles.module.scss'

export const NewSurveyButton = observer(({ className }: { className?: string }) => {
  const { openCreateModal } = useSurveysContext()

  return (
    <Button
      text='New survey'
      size='medium'
      iconProps={{ icon: 'add' }}
      onClick={openCreateModal}
      className={className}
    />
  )
})

export const GuideButton = observer(({ className }: { className?: string }) => (
  <Button
    className={classnames(styles.helpGuideButton, className)}
    tag={'a'}
    href={LINK_SURVEYS_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))
